import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=02819a9b&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=02819a9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PrivacyConsent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports